export default {
    methods: {
        formatDate(date) {
            return this.$moment.parseZone(date).local().format('DD/MM/YYYY hh:mm:ss A');
        }
    }
}